// Content for the Carpet: Keep vs. Replace resource page and quick-decision card.
// Mirrors backend rugs_section.py so the page and PDF stay consistent.

export const CARPET_INTRO =
  "Rugs and carpets influence dust, cleaning, comfort, and contact. The most reliable decisions are based on the condition of the specific carpet rather than on material type alone. Synthetic carpet, in particular, should be judged by how it is performing today, not by whether it is synthetic.";

export const CARPET_KEY_PRINCIPLE =
  "Do not replace stable, dry, cleanable synthetic carpet with new synthetic carpet solely because new feels cleaner. New synthetic carpet may reduce accumulated dust or prior contamination, but it can also introduce new carpet fibers, backing, padding, adhesives, stain treatments, and short-term emissions. Replacement makes more sense when the existing carpet has moisture damage, persistent odor, staining, poor cleanability, degraded padding, prior contamination, or is already due for replacement.";

export const CARPET_FACTORS = [
  "Moisture history", "Odor", "Dust", "Cleanability", "Padding condition",
  "Prior contamination", "Room use", "Proximity to occupants",
  "Whether replacement would introduce new materials",
  "Whether replacement is already part of a planned renovation",
];

export const CARPET_RETAIN = [
  "It is dry.",
  "It has no musty odor.",
  "There is no known water damage.",
  "The padding is not degraded or contaminated.",
  "It can be professionally cleaned and fully dried.",
  "It is not in a moisture-prone room.",
  "It is not interfering with a planned renovation.",
  "Replacement would introduce substantial cost, dust, and new materials without solving a defined problem.",
];

export const CARPET_REPLACE = [
  "It has a persistent musty odor.",
  "It has been wet or flooded.",
  "The padding may be affected.",
  "It has pet contamination, smoke odor, or heavy staining.",
  "It sheds, crumbles, or deteriorates.",
  "It cannot be cleaned effectively.",
  "It is installed over a damp slab or in a moisture-prone area.",
  "The room is a high-use bedroom, child\u2019s room, or playroom and replacement is already practical.",
];

export const CARPET_INSTALL_ASK = [
  "What fiber is used?",
  "What backing is used?",
  "What pad is used?",
  "Are stain-resistant, water-resistant, antimicrobial, or flame-resistant treatments included?",
  "Is adhesive required, or can the installation use tack strips where appropriate?",
  "Is emissions documentation available?",
  "Is the carpet certified under a relevant indoor-air emissions program?",
  "How should the room be ventilated during and after installation?",
  "How long before rugs, furniture, and children\u2019s items are placed back in the room?",
  "How should the carpet be cleaned and maintained?",
];

export const CARPET_CONCLUSION =
  "If the existing synthetic carpet is clean, dry, odor-free, and functioning, do not replace it just because it is synthetic. If it is damaged, musty, moisture-affected, contaminated, or impossible to clean, replacement may be appropriate. When replacing, evaluate the whole carpet system: fiber, backing, pad, treatments, adhesive, subfloor, ventilation, and maintenance.";
